import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout/Layout'
import Cookies from 'js-cookie'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    name: 'dashboard',
    meta: {
      title: '工作台',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        meta: {
          title: '相关统计'
        },
        name: 'Dashboard',
        component: () => import('@/components/Dashboard/Index')
      }
    ]
  },
  {
    path: '/',
    name: 'slideshow',
    meta: {
      title: '首页轮播图',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/slideshow',
    children: [
      {
        path: 'slideshow',
        meta: {
          title: '首页轮播图'
        },
        name: 'Slideshow',
        component: () => import('@/components/Pages/SlideShow')
      },
      {
        path: 'slideshow/edit',
        meta: {
          title: '首页轮播图管理'
        },
        name: 'SlideshowEdit',
        hidden: true,
        component: () => import('@/components/Pages/SlideShowEdit')
      }
    ]
  },
  {
    path: '/',
    name: 'headpic',
    meta: {
      title: '头图管理',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/headpic',
    children: [
      {
        path: 'headpic',
        meta: {
          title: '头图管理'
        },
        name: 'HeadPic',
        component: () => import('@/components/Pages/HeadPic')
      }
    ]
  },
  {
    path: '/',
    name: 'service',
    meta: {
      title: '服务方案',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/service',
    children: [
      {
        path: 'service',
        meta: {
          title: '方案管理'
        },
        name: 'Serice',
        component: () => import('@/components/Pages/Service')
      },
      {
        path: 'service/edit',
        meta: {
          title: '方案编辑'
        },
        name: 'SericeEdit',
        hidden: true,
        component: () => import('@/components/Pages/ServiceEdit')
      },
      {
        path: 'service/way',
        meta: {
          title: '方法论管理'
        },
        name: 'ServiceWay',
        component: () => import('@/components/Pages/ServiceWay')
      }
    ]
  },
  {
    path: '/',
    name: 'case',
    meta: {
      title: '案例管理'
    },
    component: Layout,
    hidden: false,
    redirect: '/case',
    children: [
      {
        path: 'case',
        meta: {
          title: '案例列表',
          keepAlive: false
        },
        name: 'Case',
        hidden: false,
        component: () => import('@/components/Pages/Case')
      },
      {
        path: 'case/edit',
        meta: {
          title: '案例编辑'
        },
        name: 'CaseEdit',
        hidden: true,
        component: () => import('@/components/Pages/CaseEdit')
      },
      {
        path: 'case/category',
        meta: {
          title: '案例分类管理'
        },
        name: 'CaseCategory',
        hidden: false,
        component: () => import('@/components/Pages/CaseCategory')
      }
    ]
  },
  {
    path: '/',
    name: 'news',
    meta: {
      title: '新闻动态',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/news',
    children: [
      {
        path: 'news',
        meta: {
          title: '新闻管理'
        },
        name: 'News',
        component: () => import('@/components/Pages/News')
      },
      {
        path: 'newstag',
        meta: {
          title: '新闻标签'
        },
        name: 'NewsTag',
        component: () => import('@/components/Pages/NewsTag')
      },
      {
        path: 'news/edit',
        meta: {
          title: '新闻编辑'
        },
        name: 'NewsEdit',
        hidden: true,
        component: () => import('@/components/Pages/NewsEdit')
      }
    ]
  },
  {
    path: '/',
    name: 'require',
    meta: {
      title: '客户需求',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/require',
    children: [
      {
        path: 'require',
        meta: {
          title: '客户需求'
        },
        name: 'Require',
        component: () => import('@/components/Pages/require')
      },
      {
        path: 'require/view',
        meta: {
          title: '需求查看'
        },
        name: 'RequireView',
        hidden: true,
        component: () => import('@/components/Pages/RequireView')
      }
    ]
  },
  {
    path: '/',
    name: 'intro',
    meta: {
      title: '企业介绍',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/intro',
    children: [
      {
        path: 'intro',
        meta: {
          title: '企业简介'
        },
        name: 'CorpIntro',
        component: () => import('@/components/Pages/CorpIntro')
      },
      {
        path: 'intro/service',
        meta: {
          title: '服务范围'
        },
        name: 'CorpService',
        component: () => import('@/components/Pages/CorpService')
      },
      {
        path: 'intro/honor',
        meta: {
          title: '资质与荣誉'
        },
        name: 'CorpHonor',
        component: () => import('@/components/Pages/CorpHonor')
      },
      {
        path: 'intro/partybuild',
        meta: {
          title: '党建要闻'
        },
        name: 'CorpPartyBuild',
        component: () => import('@/components/Pages/CorpPartyBuild')
      },
      {
        path: 'intro/newsedit',
        meta: {
          title: '党建要闻编辑'
        },
        hidden: true,
        name: 'CorpPartyBuildEdit',
        component: () => import('@/components/Pages/CorpPartyBuildEdit')
      },
      {
        path: 'intro/banner',
        meta: {
          title: '党建banner编辑'
        },
        hidden: true,
        name: 'CorpPartyBuildBanner',
        component: () => import('@/components/Pages/CorpPartyBuildBanner')
      },
      {
        path: 'intro/culture',
        meta: {
          title: '企业文化'
        },
        name: 'CorpCulture',
        component: () => import('@/components/Pages/CorpCulture')
      }
    ]
  },
  {
    path: '/',
    name: 'jobs',
    meta: {
      title: '人才中心',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/jobs',
    children: [
      {
        path: 'jobs',
        meta: {
          title: '职位列表'
        },
        name: 'Jobs',
        component: () => import('@/components/Pages/Jobs')
      },
      {
        path: 'jobs/edit',
        meta: {
          title: '职位编辑'
        },
        name: 'JobsEdit',
        hidden: true,
        component: () => import('@/components/Pages/JobsEdit')
      }
    ]
  },
  {
    path: '/',
    name: 'resume',
    meta: {
      title: '简历管理',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/resume',
    children: [
      {
        path: 'resume',
        meta: {
          title: '简历管理'
        },
        name: 'Resume',
        component: () => import('@/components/Pages/Resume')
      },
      {
        path: 'resume/view',
        meta: {
          title: '简历查看'
        },
        name: 'ResumeView',
        hidden: true,
        component: () => import('@/components/Pages/ResumeView')
      }
    ]
  },
  {
    path: '/',
    name: 'system',
    meta: {
      title: '系统管理',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/system/pageconfig',
    children: [
      {
        path: 'system/pageconfig',
        meta: {
          title: '页面基础配置'
        },
        name: 'PageConfig',
        component: () => import('@/components/Pages/PageConfig')
      },
      {
        path: 'system/other',
        meta: {
          title: '其他管理'
        },
        name: 'OtherSetting',
        component: () => import('@/components/Pages/OtherSetting')
      }
    ]
  },
  {
    path: '/',
    name: 'account',
    meta: {
      title: '权限管理',
      keepAlive: false
    },
    component: Layout,
    hidden: false,
    redirect: '/account',
    children: [
      {
        path: 'account',
        meta: {
          title: '账号列表'
        },
        name: 'Account',
        component: () => import('@/components/Pages/Account')
      },
      {
        path: 'account/edit',
        meta: {
          title: '账号管理'
        },
        hidden: true,
        name: 'AccountEdit',
        component: () => import('@/components/Pages/AccountEdit')
      },
      {
        path: 'account/groups',
        meta: {
          title: '权限组列表'
        },
        name: 'Groups',
        component: () => import('@/components/Pages/Groups')
      },
      {
        path: 'account/groupsedit',
        meta: {
          title: '权限组管理'
        },
        hidden: true,
        name: 'GroupsEdit',
        component: () => import('@/components/Pages/GroupsEdit')
      },
      {
        path: 'account/log',
        meta: {
          title: '日志查询'
        },
        name: 'AccountLog',
        component: () => import('@/components/Pages/Accountlog')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/components/Account/Login'),
    hidden: false
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/components/Modules/Redirect')
      }
    ]
  }
]

const router = new Router({
  routes: constantRouterMap
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    if (!Cookies.get('uid') || !Cookies.get('token')) {
      next({
        'path': '/login'
      })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js